export const MuiFormHelperTextNode = {
  styleOverrides: {
    root: {
      fontSize: "12px",
    },
  },
};
